import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthService {
  redirectUrl: string = '';
  
  constructor(private router: Router, private httpClient: HttpClient) { 
    
  }

  isAuthenticated(): boolean {
    const token = this.getToken();

    return !!token;
  }

  getToken(): string | null {
    const token = localStorage.getItem('token') || null;

    return token;
  }

  setToken(token: any) {
    localStorage.setItem('token', token);
  }

  getLoginConfig() {
    return this.httpClient.get<any>(`${environment.backendUrl}/api/config/login`);
  }

  deleteToken() {
    localStorage.removeItem('token');
  }

  login(email: string, password: string) {
    return this.httpClient.post<any>(`${environment.backendUrl}/api/login`, { email, password }).pipe(
      tap((response) => {
        localStorage.setItem('token', response.data.token);
      })
    );
  }

  logout() {
    if (!this.isAuthenticated()) {
      this.router.navigate(['/login']);
      return;
    }

    let headers = new HttpHeaders({
      'Authorization': `Bearer ${this.getToken()}`
    });
    return this.httpClient.post<any>(`${environment.backendUrl}/api/logout`, {}, { headers }).subscribe({
      next: (response) => {
        this.deleteToken();
        if (response.data.navigate) {
          window.location.href = response.data.navigate;
        }

        window.location.reload();
      }
    });
  }
}
